import React, { memo } from 'react';
import IconFont from '$/components/IconFont';
import useCreateRoom from '$/hooks/useCreateRoom';
import {
  clearTeamFlowSidebarOpenTarget,
  setTeamFlowSidebarOpenTarget,
} from '$/pages/RoboneoTeamFlow/Sidebar/teamFlowSidebarOpenStorage';
import { handleImageUrl } from '$/utils/image';
import { useOfficialStore } from '$/store/useOfficialStore';
import { useCommonStore } from '@/store/useCommonStore';
import { useLanguageStore } from '$/store/languageStore';
import styles from './index.module.scss';

const COVER_URL = 'https://roboneo-public.meitudata.com/public/6a573da1279036558CFf9Rr2P41972.jpeg';

/**
 * 渲染首页 AI 创作工具栏中的特效模板卡片。
 */
function EffectTemplateCard() {
  const languageStore = useLanguageStore((state) => state.languageStore);
  const initUserInfo = useCommonStore((state) => state.initUserInfo);
  const { createRoom } = useCreateRoom({
    onLoginSuccessed: async () => {
      await initUserInfo();
    },
    createAfterLogin: true,
  });

  /**
   * 创建 team_studio 房间，写入爆款模板自动打开缓存后跳转进入。
   */
  const openEffectTemplateRoom = async () => {
    // 须在 createRoom 内跳转前写入，进入房间后侧边栏才能读到目标。
    setTeamFlowSidebarOpenTarget('hotTemplate');

    const result = await createRoom({
      trackLocation: 'home_template',
    });

    // 未登录会走 createAfterLogin 重试，缓存需保留；已登录但创建失败则清掉，避免脏缓存。
    if (!result && useOfficialStore.getState().isUserLoggedIn()) {
      clearTeamFlowSidebarOpenTarget();
    }
  };

  return (
    <div
      className={styles.effectTemplateCard}
      role="button"
      tabIndex={0}
      onClick={() => {
        openEffectTemplateRoom().catch((error) => {
          console.error('[EffectTemplateCard] open room failed', error);
          clearTeamFlowSidebarOpenTarget();
        });
      }}
      onKeyDown={(event) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }
        event.preventDefault();
        openEffectTemplateRoom().catch((error) => {
          console.error('[EffectTemplateCard] open room failed', error);
          clearTeamFlowSidebarOpenTarget();
        });
      }}
    >
      <div
        className={styles.cover}
        style={{
          backgroundImage: `url(${handleImageUrl(COVER_URL, { size: 205 })})`,
        }}
      >
        <span className={styles.newBadge}>New</span>
      </div>

      <div className={styles.footer}>
        <div className={styles.footerMain}>
          <span className={styles.iconBox}>
            <IconFont name="posterTemplate" fontSize={12} color="var(--content-primary)" />
          </span>
          <span className={styles.title}>
            {languageStore.smartcatTranslationText((v) => v.effects_template)}
          </span>
        </div>
        <span className={styles.arrowBox}>
          <IconFont name="chevronRightFill" fontSize={12} color="var(--content-quaternary)" />
        </span>
      </div>
    </div>
  );
}

export default memo(EffectTemplateCard);
